<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование" : "Добавление"'
  )
  v-tabs(color='dark' slider-color='primary')
    v-tab Преимущество
    v-tab-item(:transition='false' :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs3)
              .label Выводить на сайте в "Преимуществах"
              v-checkbox(
                v-model='model.show_on_site'
                label='Показывать на сайте'
                color='primary'
              )
            v-flex(xs9)
            v-flex(xs12 v-if="attributesAdvantages")
              div Свяжите перимущество с уникальным для квартиры ИЛИ общим для дома преимуществом из 1С {{model.benefit_code}}
            v-flex(xs6 v-if="attributesAdvantages")
              v-select(
                :items='attributesAdvantages',
                v-model='uniqueness_code',
                item-value='id',
                item-text='name',
                label='Уникальность квартиры из 1С',
                clearable,
                 :disabled = 'benefit_code != null'
              )
            v-flex(xs6 v-if="attributesBenefits")
              v-select(
                :items='attributesBenefits',
                v-model='benefit_code',
                item-value='id',
                item-text='name',
                label='Преимущество дома/жк из 1С',
                clearable,
                :disabled = 'uniqueness_code != null'
              )
            v-flex(xs6)
              v-textarea(
                :error='errors.has("name")'
                :error-messages='errors.first("name")'
                :rules="[$rules.required]"
                v-model='model.name'
                rows=2
                label='Название преимущества (допустим перенос строки)'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("name_tp")'
                :error-messages='errors.first("name_tp")'
                v-model='model.name_tp'
                label='Вариант названия для "Квартиры в Казани..."'
              )
            v-flex(xs6)
              s-color-picker(
                v-model='model.name_color'
                :items = 'colors'
                label = "Цвет заголовка"
              )
            v-flex(xs6)
              s-color-picker(
                v-model='model.name_color_hover'
                :items = 'colors'
                label = "Цвет заголовка при наведении"
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("annotation")'
                :error-messages='errors.first("annotation")'
                v-model='model.annotation'
                label='Краткое описание преимущества'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("top_name")'
                :error-messages='errors.first("top_name")'
                v-model='model.top_name'
                label='Надзаголовок'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("sub_name")'
                :error-messages='errors.first("sub_name")'
                v-model='model.sub_name'
                label='Подзаголовок'
              )
            v-flex(xs12)
              s-slug-input(
                :model='model'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("default_meta.h1")'
                :error-messages='errors.first("default_meta.h1")'
                v-model='model.default_meta.h1'
                label='META.H1'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("default_meta.title")'
                :error-messages='errors.first("default_meta.title")'
                v-model='model.default_meta.title'
                label='META.title'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("default_meta.description")'
                :error-messages='errors.first("default_meta.description")'
                v-model='model.default_meta.description'
                label='META.description'
              )
            v-flex(xs6)
              s-auto-image-upload(
                ratio='auto'
                v-model='model.avatar'
                :src='model.avatar_url'
                :parseResponse='r => r.hash'
                label='Картинка (900х450)'
              )
            v-flex(xs6)
              s-auto-image-upload(
                ratio='auto'
                v-model='model.avatar_hover'
                :src='model.avatar_hover_url'
                :parseResponse='r => r.hash'
                label='Картинка при наведении (900х450)'
              )
            v-flex(xs6)
              s-auto-image-upload(
                ratio='auto'
                v-model='model.avatar_square'
                :src='model.avatar_square_url'
                :parseResponse='r => r.hash'
                label='Картинка квадратная (900х900)'
              )
            v-flex(xs6)
              s-auto-image-upload(
                ratio='auto'
                v-model='model.avatar_square_hover'
                :src='model.avatar_square_hover_url'
                :parseResponse='r => r.hash'
                label='Картинка квадратная при наведении (900х900)'
              )
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            @click='onSave'
            :loading='isLoading'
            color='primary'
            depressed
          ) Сохранить
    template(v-if='model.description')
      v-tab Подробное описание
      v-tab-item(:transition='false' :reverse-transition='false')
        v-card
          v-card-text
            v-form
              editor(:schema="description" :model="description_data")
          v-card-actions(class='large')
            v-spacer
            s-back-btn
            v-btn(
              @click='onSaveDescription'
              :loading='isLoading'
              color='primary'
              depressed
            ) Сохранить

</template>

<script>
import Editor from '@/components/editor/Index'
import http from '@/http'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],
  components: {
    Editor
  },

  data: () => ({
    model: {
      default_meta: {}
    },
    description: null,
    description_data: {},
    colors: [
                  { id: "#000000" , name: '#000000' },
                  { id: "#232020" , name: '#232020' },
                  { id: "#ffffff" , name: '#fffff' },
                  { id: "#29973c" , name: '#29973c' },
                  { id: "#72b737" , name: '#72b737' }
                ],
    attributesAdvantages: [],
    attributesBenefits: []
  }),

  async created() {
    if (this.id) {
      this.updateItem()
    }
    this.fetchAttributes()
  },

  methods: {
    async updateItem() {
      this.model = (await this.fetchSingle({ id: this.id })).data
      if (this.model.description)
        this.description = this._parseResponse(this.model.description.json_scheme)
        this.description_data = this._parseResponse(this.model.description.data)
    },

    async fetchAttributes() {
      try {
        let res = await http.get('/data/1c/advantages')
        this.attributesAdvantages = res.data
        res = await http.get('/data/1c/benefits')
        this.attributesBenefits = res.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки справочников')
      }
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Advantages.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onSaveDescription() {
      try {
        let payload = {
          data: JSON.stringify(this.description_data)
        }
        await http.post(`/dictionary/advantages/${this.id}/description`, payload)

        this.$root.showSnack('Сохранено')
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    },

    ...mapActions('dictionaries/advantages', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    uniqueness_code: {
      get() {
        return this.model.uniqueness_code
      },
      set(val) {
        this.model.uniqueness_code = val || null
        this.model.uniqueness_name = null
      },
    },
    benefit_code: {
      get() {
        return this.model.benefit_code
      },
      set(val) {
        this.model.benefit_code = val || null
      },
    },
    ...mapGetters('dictionaries/advantages', ['isLoading'])
  }
}
</script>
